import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {

  pdfUrl = 'assets/pdf/vaishcollege-applicationform.pdf';
  onlineFormUrl = 'https://data.odpay.in/odforms1/form/SDPGCollegeApplicationFormForPostPrincipal/formperma/Ylb0Y_AtvCJmGjztWYsX7RGayVH__lz-hPQriehxBD4';

  constructor() { }

  ngOnInit(): void {
  }

}
